"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PrivacyAcknowledgement;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const PrivacyNoticeSections_1 = __importDefault(require("./PrivacyNoticeSections"));
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
function PrivacyAcknowledgement({ load, acknowledge, onContinue, onLogout, logoutLabel = "Wyloguj się" }) {
    const [status, setStatus] = (0, react_1.useState)(null);
    const [checked, setChecked] = (0, react_1.useState)(false);
    const [busy, setBusy] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    async function refresh() {
        setBusy(true);
        setError("");
        setChecked(false);
        setStatus(null);
        try {
            const next = await load();
            setStatus(next);
            if (next.acknowledged)
                onContinue?.();
        }
        catch {
            setError("Nie udało się pobrać informacji. Sprawdź połączenie i spróbuj ponownie.");
        }
        finally {
            setBusy(false);
        }
    }
    (0, react_1.useEffect)(() => { void refresh(); }, [load]);
    async function confirm() {
        if (!checked || !status || busy)
            return;
        setBusy(true);
        setError("");
        try {
            const next = await acknowledge(status.notice);
            if (!next.acknowledged)
                throw new Error();
            setStatus(next);
            onContinue?.();
        }
        catch (err) {
            setChecked(false);
            if (err.status === 409) {
                await refresh();
                setError("Informacja została zmieniona. Zapoznaj się z aktualną treścią i potwierdź ponownie.");
            }
            else
                setError("Nie udało się zapisać potwierdzenia. Spróbuj ponownie.");
        }
        finally {
            setBusy(false);
        }
    }
    if (busy && !status)
        return react_1.default.createElement(react_bootstrap_1.Container, { role: "status", "aria-label": "Trwa \u0142adowanie", className: "d-flex justify-content-center align-items-center min-vh-100" },
            react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null));
    return react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4", style: { maxWidth: 850 } },
        react_1.default.createElement("h1", { className: "h4 mb-3" }, status?.notice.title || "Prywatność i dane osobowe"),
        busy && react_1.default.createElement("p", { role: "status" }, "Trwa \u0142adowanie..."),
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
        !status && !busy && react_1.default.createElement(react_bootstrap_1.Button, { onClick: refresh }, "Spr\u00F3buj ponownie"),
        status && react_1.default.createElement(react_1.default.Fragment, null,
            onContinue && react_1.default.createElement("p", null, "Przed przej\u015Bciem dalej zapoznaj si\u0119 z poni\u017Csz\u0105 informacj\u0105. Potwierdzenie zapami\u0119tamy, aby nie pyta\u0107 przy kolejnej wizycie."),
            react_1.default.createElement(PrivacyNoticeSections_1.default, { sections: status.notice.sections }),
            onContinue && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "privacy-acknowledgement", checked: checked, disabled: busy, onChange: e => setChecked(e.target.checked), label: "Potwierdzam zapoznanie si\u0119 z informacj\u0105 o przetwarzaniu danych osobowych." }),
                react_1.default.createElement(react_bootstrap_1.Button, { className: "mt-3", disabled: !checked || busy, onClick: confirm }, "Przejd\u017A dalej"))),
        react_1.default.createElement("div", { className: "mt-4 d-flex gap-3 align-items-center flex-wrap" },
            react_1.default.createElement("a", { href: "mailto:biuro@envi.com.pl" }, "Kontakt z biurem"),
            onLogout && react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", disabled: busy, onClick: async () => {
                    try {
                        await onLogout();
                    }
                    catch {
                        setError("Nie udało się wylogować. Spróbuj ponownie.");
                    }
                } }, logoutLabel)));
}
